import { Image } from "antd";
import { useEffect, useState } from "react";
import { dateToString } from "../../utils/formatter";
import OverallComplianceStatus from "./components/OverallComplianceStatus";
import NonCompliantParameters from "./components/NonCompliantParameters";
import ParameterOverview from "./components/ParameterOverview";
import TestResults from "./components/TestResults";
import { useDispatch, useSelector } from "react-redux";
import {actions} from '../../pages/authenticatedApp/backoffice/OrderDetails/slice'
import * as selectors from '../../pages/authenticatedApp/backoffice/OrderDetails/selectors'

const LabRejectedBlock = ({ orderDetails }) => {
  const reason = orderDetails?.sampleReceivedByLabDetails?.rejectedByLabReason;
  const images =
    orderDetails?.sampleReceivedByLabDetails?.rejectedByLabPhotos || [];
  const labName = orderDetails?.assignedLab?.name || "N/A";

  return (
    <div style={{ marginBottom: "1rem" }}>
      <p style={{ marginBottom: "0.4em" }}>
        <strong>Assigned Lab: </strong> {labName}
      </p>

      {reason && (
        <p style={{ marginBottom: "0.4em" }}>
          <strong>Rejected Reason: </strong> {reason}
        </p>
      )}

      {images.length > 0 && (
        <div style={{ marginTop: "0.4em" }}>
          <p style={{ fontWeight: "bold", marginBottom: "0.4em" }}>
            Rejected Photos:
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {images.map((photo, index) => (
              <Image
                key={index}
                src={photo}
                alt={`Rejected image ${index + 1}`}
                width={200}
                height={200}
                style={{
                  cursor: "pointer",
                  objectFit: "contain",
                }}
                preview={{
                  mask: "Click to view",
                }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const LabDetailsBlock = ({ data }) => {
  const [showDetails, setShowDetails] = useState(false);
  const labDetails = data.labDetails;
  const sampleReceivedByLabDetails = data.sampleReceivedByLabDetails;
  const variant = data.variant;
  const labelingPhotos = sampleReceivedByLabDetails?.labelingPhotos || [];

  return (
    <div
      style={{
        border: "1px dashed #ddd",
        borderRadius: 8,
        padding: "20px 30px",
        marginBottom: 30,
        background: "#fff",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {" "}
        <p style={{ marginBottom: "0.4em" }}>
          <span style={{ fontWeight: "bold" }}>Assigned Lab:</span>{" "}
          {labDetails?.name}
        </p>
        {showDetails ? (
          <p
            onClick={() => setShowDetails(false)}
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            Hide Details
          </p>
        ) : (
          <p
            onClick={() => setShowDetails(true)}
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            More Details
          </p>
        )}
      </div>
      {showDetails ? (
        <div>
          <p style={{ marginBottom: "0.4em" }}>
            <span style={{ fontWeight: "bold" }}>
              Expected Completion Date:
            </span>{" "}
            {dateToString(sampleReceivedByLabDetails?.expectedDateOfCompletion)}
          </p>
          {variant !== "Loose" && (
            <>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>FSSAI Logo Present:</span>{" "}
                {sampleReceivedByLabDetails?.fssaiLogoPresent}
              </p>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>
                  FSSAI License Number:
                </span>{" "}
                {sampleReceivedByLabDetails?.fssaiLicenseNumber}
              </p>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>Brand Name:</span>{" "}
                {sampleReceivedByLabDetails?.brandName}
              </p>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>Manufacturing Date:</span>{" "}
                {dateToString(sampleReceivedByLabDetails?.manufacturingDate)}
              </p>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>Lot Number:</span>{" "}
                {sampleReceivedByLabDetails?.lotNumber}
              </p>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>Expiry Date:</span>{" "}
                {dateToString(sampleReceivedByLabDetails?.expireByDate)}
              </p>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>
                  Veg/Non Veg Logo Present:
                </span>{" "}
                {sampleReceivedByLabDetails?.vegSymbolPresent}
              </p>
              <p style={{ marginBottom: "0.4em" }}>
                <span style={{ fontWeight: "bold" }}>Veg/Non Veg:</span>{" "}
                {sampleReceivedByLabDetails?.vegOrNonVeg}
              </p>
            </>
          )}
          {variant === "Organic" && (
            <p style={{ marginBottom: "0.4em" }}>
              <span style={{ fontWeight: "bold" }}>
                Jaivik Kisan Logo Present:
              </span>

              {sampleReceivedByLabDetails?.jaivikKisanLogoPresent}
            </p>
          )}

          <p style={{ marginBottom: "0.4em" }}>
            <span style={{ fontWeight: "bold" }}>Manufacturing Address:</span>{" "}
            {sampleReceivedByLabDetails?.manufacturingAddress}
          </p>
          <p style={{ marginBottom: "0.4em" }}>
            <span style={{ fontWeight: "bold" }}>
              Country of Origin Present:
            </span>{" "}
            {sampleReceivedByLabDetails?.countryOfOriginPresent}
          </p>
          <p style={{ marginBottom: "0.4em" }}>
            <span style={{ fontWeight: "bold" }}>Country of Origin:</span>{" "}
            {sampleReceivedByLabDetails?.countryOfOrigin}
          </p>
          <p style={{ fontWeight: "bold", marginBottom: "0.4em" }}>
            Labeling Photos:
          </p>
          {labelingPhotos.length ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
              {labelingPhotos.map((photo, index) => (
                <Image
                  key={index}
                  src={photo}
                  alt={`Labeling Photo ${index + 1}`}
                  width={200}
                  height={200}
                  style={{
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                  preview={{
                    mask: "Click to view",
                  }}
                />
              ))}
            </div>
          ) : null}
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

const LabResponse = ({ dataForKeyParameterValues, packages, orderDetails }) => {
  const dispatch = useDispatch();
  const orderStatus = orderDetails?.status?.value;

  const [isLabAnalyticsLoading, setIsLabAnalyticsLoading] = useState(false);
  const labAnalyticsDetails = useSelector(selectors.selectLabAnalytics);

  const id = orderDetails?._id;
  useEffect(() => {
    if (["reportUploaded", "underDispute", "completed"].includes(orderStatus)) {
      setIsLabAnalyticsLoading(true);
      dispatch(
        actions.fetchLabAnalyticsDetails({
          id,
          onSuccess: () => {
            setIsLabAnalyticsLoading(false);
          },
          onFailure: () => {
            setIsLabAnalyticsLoading(false);
          },
        })
      );
    }
  }, [dispatch, id, orderStatus]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <div
          style={{
            padding: "20px 30px",
            border: "1px solid #E0E0E0",
            borderRadius: 8,
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ flex: 1 }}>
            <p
              style={{
                fontWeight: "bold",
                fontSize: 16,
                paddingBottom: "5px",
                borderBottom: "1px solid #D9D9D9",
              }}
            >
              {orderStatus === "rejectedByLab"
                ? "Sample Rejected by Lab"
                : "Sample Received By Lab Details"}
            </p>

            {orderStatus === "rejectedByLab" ? (
              <LabRejectedBlock orderDetails={orderDetails} />
            ) : (
              <LabDetailsBlock
                data={{
                  labDetails: orderDetails.assignedLab,
                  sampleReceivedByLabDetails:
                    orderDetails.sampleReceivedByLabDetails,
                  variant: orderDetails.sampleVariant,
                }}
              />
            )}
          </div>
        </div>

        <OverallComplianceStatus labAnalyticsDetails={labAnalyticsDetails} isLoading={isLabAnalyticsLoading} />
        <NonCompliantParameters labAnalyticsDetails={labAnalyticsDetails} isLoading={isLabAnalyticsLoading} />
        <ParameterOverview labAnalyticsDetails={labAnalyticsDetails} isLoading={isLabAnalyticsLoading} />
        <TestResults labAnalyticsDetails={labAnalyticsDetails} isLoading={isLabAnalyticsLoading} />
      </div>
    </>
  );
};

export default LabResponse;
